import firebase from 'firebase/compat/app';

import { createContext } from 'react';
import { FirebaseAuthWithDataProps } from '.';

export type FirebaseUser = firebase.User | null;

interface Context {
    user: FirebaseUser;
    userSignOut: () => Promise<void>;
    auth: firebase.auth.Auth;
    getCurrentUser: () => Promise<unknown>;
    firebaseFormSubmit: ({
        type,
        data,
    }: FirebaseAuthWithDataProps) => Promise<unknown>;
}

export const FirebaseContext = createContext<Context>(undefined!);
